import styled from 'styled-components'
import { m as motion } from 'framer-motion'
import { media, Section, Title } from '../styles/globalStyles'

export const ContactSec = styled(Section)`
  .Scroller {
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    padding: 0 11.7862%;
    ${media.lessThan('desktop15')`
      padding: 0 10%;
    `};
    ${media.lessThan('miniTablet')`
      padding: 0 8.5rem 0 3.25rem;
    `};
    ${media.lessThan('phone')`
      padding: 9rem 1.5625rem 2.5rem;
    `};
    ${media.lessThan('miniPhone')`
      padding-top: 5rem;
    `};
  }
`

export const ContactWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  height: auto;
  min-height: 100%;
  overflow-x: hidden;
  ${media.lessThan('phone')`
    display: block;
  `};
`

export const ContactTitle = styled(Title)`
  font-size: 3.75rem;
  line-height: 4.25rem;
  text-transform: uppercase;
  margin-bottom: 2.5rem;
  ${media.lessThan('phone')`
    font-size: 3.75rem;
    line-height: 3.25rem;
  `};
  ${media.lessThan('miniPhone')`
    font-size: 2.8125rem;
    line-height: 3.125rem;
  `};
`

export const ContactSections = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 3fr 2fr;
  grid-gap: 10%;
  padding-right: 5%;
  & > .copy {
    display: none;
  }
  ${media.lessThan('desktop12')`
    padding-right: 0;
  `};
  ${media.lessThan('tablet')`
    display: block;
    .copy {
      display: block;
      margin-top: 2.5rem;
    }
  `};
  ${media.lessThan('phone')`
    .copy {
      padding-right: 40%;
    }
  `};
`

export const ContactSection = styled(motion.div)` 
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  &:nth-child(2){
    flex-basis: calc(33.6538% - 3.5rem);
    ${media.lessThan('tablet')`
      flex-basis: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 4rem;
    `};
    ${media.lessThan('miniTablet')`
      grid-gap: 2.5rem;
    `};
    ${media.lessThan('phone')`
      display: block;
    `};
  }
  .Social {
    margin-bottom: 3rem;
  }
  ${media.lessThan('tablet')`
  .copy {
    display: none;
  }
  `}
`

export const People = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 2.1875rem 5rem;
  margin-bottom: 4.375rem;
  ${media.lessThan('tablet')`
    grid-gap: 3.5rem 0;
  `};
  ${media.lessThan('miniTablet')`
    grid-template-columns: 1fr 1fr;
  `};
  ${media.lessThan('phone')`
    grid-template-columns: 1fr;
    margin-bottom: 3rem;
  `};
`

export const Address = styled.p`
  font-size: 1.75rem;
  line-height: 2.1875rem;
  font-weight: 300;
  letter-spacing: 0.01rem;
  margin-bottom: 1rem;
`

export const Phone = styled.p`
  font-size: 1.3125rem;
  line-height: 1.75rem;
  font-weight: 300;
  letter-spacing: 0.01rem;
  margin-bottom: 1rem;
`

export const Email = styled.a`
  font-size: 1.3125rem;
  line-height: 1.75rem;
  color: ${(props) => props.theme.orange};
  margin: 1.5rem 0;
  ${media.greaterThan('phone')`
    transition: color 300ms linear;
    will-change: color;
    &:hover {
      color: black;
    }
  `}
`

export const Map = styled.a`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  font-size: 1.125rem;
  line-height: 1.25rem;
  font-weight: 700;
  letter-spacing: 0.01rem;
  color: black;
  margin-top: 3rem;
  span {
    width: 0.8125rem;
    margin-right: 0.875rem;
    ${media.greaterThan('phone')`
      svg {
        transition: all 300ms;
        transition-property: fill;
        will-change: fill;
      }
    `}
  }
  ${media.greaterThan('phone')`
    transition: all 300ms;
    transition-property: color;
    will-change: color;
    &:hover {
      color: ${(props) => props.theme.orange};
      span {
        svg {
          fill: ${(props) => props.theme.orange};
        }
      }
    }
  `}
`

export const ContactItemWrapper = styled.div`
  h3 {
    font-size: 0.9375rem;
    line-height: 1.125rem;
    font-weight: 700;
    letter-spacing: 0.01rem;
    margin-bottom: 0.625rem;
    ${media.lessThan('desktop15')`
      font-size: 1.125rem;
      line-height: 1.3125rem;
    `};
    span {
      display: block;
      font-weight: 400;
    }
  }
  p,
  a {
    display: block;
    font-size: 0.8125rem;
    line-height: 1.125rem;
    letter-spacing: 0.01rem;
    ${media.lessThan('desktop15')`
      font-size: 1rem;
      line-height: 1.3125rem;
    `};
  }

  a {
    color: black;
    ${media.greaterThan('phone')`
      transition: all 300ms;
      transition-property: color;
      will-change: color;
      &:hover {
        color: ${(props) => props.theme.orange};
      }
    `}
  }
`

export const Copyright = styled(motion.div)`
  margin-top: auto;
  ${media.lessThan('tablet')`
    margin-top: 1.5rem;
  `}
  ${media.lessThan('phone')`
    margin-top: 3.5rem;
  `}
  p {
    font-size: 0.75rem;
    line-height: 1rem;
  }
`